// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Routing title styling - matching store order font style */
.routing-title {
    position: relative;
    display: flex;
    align-items: center;
}

.routing-title p {
    font-size: 25px;
    padding: 10px;
    margin: 0;
}

/* DC dropdown styling */
.routing-dc-dropdown {
    position: absolute;
    right: 20px;
    top: 10px;
}

.customSelect {
    width: 300px;
    padding: 8px;
    font-size: 12px;
    border: 1px solid #0A74DA;
    font-weight: bold;
    background-color: white;
    border-radius: 5px;
    cursor: pointer;
}

.customSelect.disabled {
    color: grey;
    cursor: not-allowed;
}

.customSelect.enabled {
    color: #0A74DA;
}

/* Ensure tab labels display in title case */
.MuiTab-root {
    text-transform: none !important;
}

/* Table styling */
.MuiTableContainer-root {
    margin-top: 16px;
    max-height: 600px;
    overflow-y: auto;
}

.MuiTableHead-root .MuiTableCell-root {
    background-color: #f5f5f5;
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 1;
}

.MuiTableRow-root:hover {
    background-color: #f9f9f9;
}

/* Route icons styling */
.route-icons-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    min-height: 24px;
    padding: 2px 4px;
    gap: 8px;
}

.route-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    min-height: 24px;
}

.route-icon {
    width: 20px;
    height: 20px;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s ease;
    flex-shrink: 0;
    cursor: pointer;
}

.route-icon:hover {
    background-color: rgba(25, 118, 210, 0.08);
    color: #1976d2;
    transform: scale(1.05);
}

.route-icon-regular {
    border-radius: 6px;
    background-color: transparent;
    color: #1976d2;
}

.route-icon-regular:hover {
    background-color: rgba(25, 118, 210, 0.1);
    color: #1565c0;
    transform: scale(1.05);
}

.route-icon-fallback {
    font-size: 12px;
    color: #666;
    padding: 2px 4px;
    background-color: #f5f5f5;
    border-radius: 3px;
    margin: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/components/routing/Routing.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,SAAS;AACb;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,4CAA4C;AAC5C;IACI,+BAA+B;AACnC;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf","sourcesContent":["/* Routing title styling - matching store order font style */\n.routing-title {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.routing-title p {\n    font-size: 25px;\n    padding: 10px;\n    margin: 0;\n}\n\n/* DC dropdown styling */\n.routing-dc-dropdown {\n    position: absolute;\n    right: 20px;\n    top: 10px;\n}\n\n.customSelect {\n    width: 300px;\n    padding: 8px;\n    font-size: 12px;\n    border: 1px solid #0A74DA;\n    font-weight: bold;\n    background-color: white;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.customSelect.disabled {\n    color: grey;\n    cursor: not-allowed;\n}\n\n.customSelect.enabled {\n    color: #0A74DA;\n}\n\n/* Ensure tab labels display in title case */\n.MuiTab-root {\n    text-transform: none !important;\n}\n\n/* Table styling */\n.MuiTableContainer-root {\n    margin-top: 16px;\n    max-height: 600px;\n    overflow-y: auto;\n}\n\n.MuiTableHead-root .MuiTableCell-root {\n    background-color: #f5f5f5;\n    font-weight: 600;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n}\n\n.MuiTableRow-root:hover {\n    background-color: #f9f9f9;\n}\n\n/* Route icons styling */\n.route-icons-container {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-wrap: wrap;\n    width: 100%;\n    min-height: 24px;\n    padding: 2px 4px;\n    gap: 8px;\n}\n\n.route-icon-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 24px;\n    min-height: 24px;\n}\n\n.route-icon {\n    width: 20px;\n    height: 20px;\n    color: #666;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    transition: all 0.2s ease;\n    flex-shrink: 0;\n    cursor: pointer;\n}\n\n.route-icon:hover {\n    background-color: rgba(25, 118, 210, 0.08);\n    color: #1976d2;\n    transform: scale(1.05);\n}\n\n.route-icon-regular {\n    border-radius: 6px;\n    background-color: transparent;\n    color: #1976d2;\n}\n\n.route-icon-regular:hover {\n    background-color: rgba(25, 118, 210, 0.1);\n    color: #1565c0;\n    transform: scale(1.05);\n}\n\n.route-icon-fallback {\n    font-size: 12px;\n    color: #666;\n    padding: 2px 4px;\n    background-color: #f5f5f5;\n    border-radius: 3px;\n    margin: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
